'use client';
import { jsx } from 'react/jsx-runtime';
import { useOverlayTrigger } from '@react-aria/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { useRef, useMemo } from 'react';
import { SwanPopoverContextProvider } from './popover.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(o, r) {
    if (null == o) return {};
    var e, t, p = _object_without_properties_loose(o, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(o);
        for(t = 0; t < n.length; t++)e = n[t], !(r.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(o, e) && (p[e] = o[e]);
    }
    return p;
}
function _object_without_properties_loose(o, r) {
    if (null == o) return {};
    var e, t, p = {}, n = Object.keys(o);
    for(t = 0; t < n.length; t++)e = n[t], r.indexOf(e) >= 0 || (p[e] = o[e]);
    return p;
}
const Popover = renderWithRef('Popover', null, (l, u)=>{
    useComponentStylesLoaded('Popover', SWAN_STYLE_KEY_MAP.popover);
    let { position: f = 'top', children: v } = l, _ = _object_without_properties(l, [
        "position",
        "children"
    ]), d = useRef(null), y = assignRefs(u, d), h = useRef(null), b = useOverlayTriggerState({}), j = useModeExtractor(d, b.isOpen), { overlayProps: O, triggerProps: w } = useOverlayTrigger({
        type: 'dialog'
    }, b, h);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                modes: j,
                popoverRef: d,
                triggerRef: h,
                overlayState: b,
                overlayProps: O,
                triggerProps: w,
                popoverPlacement: null != f ? f : 'top'
            }), [
            h,
            d,
            b,
            O,
            w,
            f,
            j
        ]),
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: y,
            classNames: [
                'swan-popover-container'
            ],
            props: _,
            children: v
        })
    });
});

export { Popover };
